"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var MeApi = /** @class */ (function () {
    function MeApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取账号信息
     * @method GET 获取账号信息
     *
     */
    MeApi.prototype.account = function () {
        return this.http
            .url("/Me/account")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 更新个人资料
     * @method PUT 更新个人资料
     *
     */
    MeApi.prototype.profile = function () {
        return this.http
            .url("/Me/profile")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 更新手机号
     * @method PUT 更新手机号
     *
     */
    MeApi.prototype.phone = function () {
        return this.http
            .url("/Me/phone")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 是否可购买会员
     * @method GET 是否可购买会员
     *
     */
    MeApi.prototype.canupdate = function () {
        return this.http
            .url("/Me/membership/canupdate")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 是否可购买会员升级
     * @method GET 是否可购买会员升级
     *
     */
    MeApi.prototype.canupgrad = function () {
        return this.http
            .url("/Me/membership/canupgrad")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 设置是否禁用引荐返利
     * @method PUT 设置是否禁用引荐返利
     *
     */
    MeApi.prototype.disablereferal = function () {
        return this.http
            .url("/Me/disablereferal")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 查询通知消息
     * @method GET 查询通知消息
     *
     */
    MeApi.prototype.notification = function () {
        return this.http
            .url("/Me/notification")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 将通知消息设为已读
     * @method PUT 将通知消息设为已读
     *
     * @params id 无说明
     */
    MeApi.prototype.read = function (id) {
        return this.http
            .url("/Me/notification/" + id + "/read")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 删除通知消息
     * @method DELETE 删除通知消息
     *
     * @params id 无说明
     */
    MeApi.prototype.notificationById = function (id) {
        return this.http
            .url("/Me/notification/" + id)
            .addSecurityHeaders()
            .support('DELETE');
    };
    /**
     * 查询多级分销下线
     * @method GET 查询多级分销下线
     *
     */
    MeApi.prototype.lower = function () {
        return this.http
            .url("/Me/referal/lower")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询上线
     * @method GET 查询上线
     *
     */
    MeApi.prototype.upper = function () {
        return this.http
            .url("/Me/referal/upper")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询邀请注册记录
     * @method GET 查询邀请注册记录
     *
     */
    MeApi.prototype.regist = function () {
        return this.http
            .url("/Me/referal/regist")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询优惠券
     * @method GET 查询优惠券
     *
     */
    MeApi.prototype.coupon = function () {
        return this.http
            .url("/Me/coupon")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询优惠券数量
     * @method GET 查询优惠券数量
     *
     */
    MeApi.prototype.couponCount = function () {
        return this.http
            .url("/Me/coupon/count")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 领取优惠券
     * @method POST 领取优惠券
     *
     * @params id 无说明
     */
    MeApi.prototype.obtain = function (id) {
        return this.http
            .url("/Me/coupon/" + id + "/obtain")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 获取名片信息,更新名片
     * @method GET 获取名片信息
     * @method POST 更新名片
     *
     */
    MeApi.prototype.businesscard = function () {
        return this.http
            .url("/Me/seller/businesscard")
            .addSecurityHeaders()
            .support('GET', 'POST');
    };
    /**
     * 获取钱包信息
     * @method GET 获取钱包信息
     *
     */
    MeApi.prototype.wallet = function () {
        return this.http
            .url("/Me/wallet")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取收支明细
     * @method GET 获取收支明细
     *
     */
    MeApi.prototype.balance = function () {
        return this.http
            .url("/Me/wallet/balance")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取返利明细
     * @method GET 获取返利明细
     *
     */
    MeApi.prototype.rebate = function () {
        return this.http
            .url("/Me/wallet/rebate")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取返利统计数据
     * @method GET 获取返利统计数据
     *
     */
    MeApi.prototype.sum = function () {
        return this.http
            .url("/Me/wallet/rebate/sum")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 提现申请,提现申请查询
     * @method POST 提现申请
     * @method GET 提现申请查询
     *
     */
    MeApi.prototype.withdraw = function () {
        return this.http
            .url("/Me/wallet/withdraw")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 获取订单列表
     * @method GET 获取订单列表
     *
     */
    MeApi.prototype.order = function () {
        return this.http
            .url("/Me/order")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取指定Id订单
     * @method GET 获取指定Id订单
     *
     * @params id 无说明
     */
    MeApi.prototype.orderById = function (id) {
        return this.http
            .url("/Me/order/" + id)
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 订单量统计
     * @method GET 订单量统计
     *
     */
    MeApi.prototype.orderCount = function () {
        return this.http
            .url("/Me/order/count")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询会员订单号
     * @method GET 查询会员订单号
     *
     */
    MeApi.prototype.memberorder = function () {
        return this.http
            .url("/Me/order/memberorder")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 取消订单
     * @method PUT 取消订单
     *
     * @params id 无说明
     */
    MeApi.prototype.cancel = function (id) {
        return this.http
            .url("/Me/order/" + id + "/cancel")
            .addSecurityHeaders()
            .support('PUT');
    };
    /**
     * 查询订单物流
     * @method GET 查询订单物流
     *
     * @params id 无说明
     */
    MeApi.prototype.logistic = function (id) {
        return this.http
            .url("/Me/order/" + id + "/logistic")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取存酒数量
     * @method GET 获取存酒数量
     *
     */
    MeApi.prototype.storageCount = function () {
        return this.http
            .url("/Me/storage/count")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取存酒列表
     * @method GET 获取存酒列表
     *
     */
    MeApi.prototype.items = function () {
        return this.http
            .url("/Me/storage/items")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 发起提货申请,查询提货记录
     * @method POST 发起提货申请
     * @method GET 查询提货记录
     *
     */
    MeApi.prototype.take = function () {
        return this.http
            .url("/Me/storage/take")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 确认提货收货
     * @method POST 确认提货收货
     *
     * @params id 无说明
     */
    MeApi.prototype.receive = function (id) {
        return this.http
            .url("/Me/storage/take/" + id + "/receive")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 查询提货物流信息
     * @method POST 查询提货物流信息
     *
     * @params id 无说明
     */
    MeApi.prototype.postLogistic = function (id) {
        return this.http
            .url("/Me/storage/" + id + "/logistic")
            .addSecurityHeaders()
            .support('POST');
    };
    /**
     * 创建代理申请,获取待审核代理申请
     * @method POST 创建代理申请
     * @method GET 获取待审核代理申请
     *
     */
    MeApi.prototype.agentapply = function () {
        return this.http
            .url("/Me/agentapply")
            .addSecurityHeaders()
            .support('POST', 'GET');
    };
    /**
     * 是否代理身份
     * @method GET 是否代理身份
     *
     */
    MeApi.prototype.isagent = function () {
        return this.http
            .url("/Me/isagent")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取关注公众号二维码Url
     * @method GET 获取关注公众号二维码Url
     *
     */
    MeApi.prototype.mpqr = function () {
        return this.http
            .url("/Me/mpqr")
            .addSecurityHeaders()
            .support('GET');
    };
    MeApi.diOptions = di_1.default.options({
        name: "MeApi",
        scope: "Singleton"
    });
    return MeApi;
}());
exports.MeApi = MeApi;
exports.default = MeApi;
